// src/components/layout/Header.jsx (UPDATED for Mobile Menu Logic)
import React, { useState } from 'react';
import Button from '../ui/button';
import AuthModal from '../ui/AuthModal';

const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // NEW STATE for Mobile Menu

  const navLinks = [
    { name: 'Dashboard', href: '#', active: true },
    { name: 'Markets', href: '#markets' },
    { name: 'Trade', href: '#trade' },
    { name: 'Portfolio', href: '#portfolio' },
    { name: 'Rewards', href: '#rewards' },
    { name: 'Learn', href: '#learn' },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    // Close menu when a link is clicked
    setIsMenuOpen(false);
  };

  return (
    <>
      <header>
        <div className="container nav-container">
          <a href="#" className="logo">
            <i className="fas fa-chart-line"></i>
            Kinetix
          </a>

          {/* Nav links and actions are wrapped in a single container for mobile */}
          <nav className={`nav-wrapper ${isMenuOpen ? 'active' : ''}`}>
            
            <div className="nav-links">
              {navLinks.map((link) => (
                <a 
                  key={link.name} 
                  href={link.href} 
                  className={link.active ? 'active' : ''}
                  onClick={handleLinkClick} // Close menu on click
                >
                  {link.name}
                </a>
              ))}
            </div>

            <div className="nav-actions">
              <Button variant="outline" onClick={() => { setIsModalOpen(true); setIsMenuOpen(false); }}>Log In</Button>
              <Button variant="primary" onClick={() => { setIsModalOpen(true); setIsMenuOpen(false); }}>Sign Up</Button>
            </div>
          </nav>

          <button className="mobile-menu-btn" onClick={toggleMenu}>
            <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>
        </div>
      </header>
      
      <AuthModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default Header;